import * as React from 'react';
import styled from 'styled-components';
import { __ } from 'react-i18n';

export interface Props {
  searchInput: string;
  searchInputStatus: boolean;
  handleSearchInput: (e) => void;
  setSearchInputStatus: (data: boolean) => void;
}

export class AnimatedSearch extends React.Component<Props, {}> {
  handleInput = e => {
    this.props.handleSearchInput(e);
  };

  render() {
    const { searchInput } = this.props;

    return (
      <Wrap>
        <Input
          className={this.props.searchInputStatus ? 'focus' : ''}
          onClick={this.props.setSearchInputStatus.bind(this, true)}
          placeholder={__('Hľadať')}
          value={searchInput}
          onKeyDown={this.handleInput}
          onChange={this.handleInput}
        />
      </Wrap>
    );
  }
}

const Input = styled.input`
  width: 60px;
  height: 60px;
  border-radius: 180px;
  border: none;
  cursor: pointer;
  background: ${({ theme }) => theme.btnPrimary};
  padding: 30px;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${({ theme }) => theme.fontSizeS};
  background-image: url(/images/magnifier.svg);
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 25px;
  transition: width 0.4s ease-in-out, background-color 0.4s ease-in-out,
    background-image 0.2s ease-in-out, background-size 0.2s ease-in-out 0.4s,
    background-position 0.2s ease-in-out 0.4s, opacity 0.2s;

  &:focus {
    outline: none;
  }

  &:hover {
    opacity: 0.8;
    transition: width 0.4s ease-in-out, background-color 0.4s ease-in-out,
      background-image 0.2s ease-in-out, background-size 0.02s ease-in-out,
      background-position 0.02s ease-in-out, opacity 0.2s;
  }
`;

const Wrap = styled.div`
  & > .focus {
    width: 400px;
    cursor: auto;
    padding-right: 18%;
    background-color: ${({ theme }) => theme.colors.white || theme.white};
    background-image: url('/images/magnifierBlue.svg');
    background-size: 25px;
    background-position: calc(100% - 20px) 50%;

    @media only screen and (max-width: 1050px) {
      width: 265px;
    }
  }
`;
